/**
 * Wishlist functionality for Shopify Dawn theme
 */
class Wishlist {
  constructor() {
    this.storageKey = 'shop_wishlist';
    this.wishlistItems = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    this.wishlistContainer = document.getElementById('wishlist-container');
    this.wishlistEmpty = document.getElementById('wishlist-empty');
    this.headerWishlistCount = document.querySelector('.wishlist-count');
    
    this.init();
  }

  init() {
    this.updateHeaderCount();
    this.initButtons();
    
    // If we're on the wishlist page, load the items
    if (this.wishlistContainer) {
      this.loadWishlistItems();
    }
  }

  initButtons() {
    // Add event listeners to all wishlist buttons
    const buttons = document.querySelectorAll('.wishlist-button');
    buttons.forEach(button => {
      // Skip buttons that already have event listeners
      if (button.dataset.initialized) return;
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleWishlistItem(button);
      });
      
      // Check if this product is in the wishlist and update button state
      const productId = button.dataset.productId;
      if (this.isInWishlist(productId)) {
        button.classList.add('is-active');
      }
      
      // Mark button as initialized
      button.dataset.initialized = 'true';
    });
  }

  toggleWishlistItem(button) {
    const productId = button.dataset.productId;
    const isInWishlist = this.isInWishlist(productId);
    
    if (isInWishlist) {
      this.removeFromWishlist(productId);
      button.classList.remove('is-active');
    } else {
      this.addToWishlist({
        id: productId,
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage,
        price: button.dataset.productPrice,
        raw_price: button.dataset.rawPrice,
        variant_id: button.dataset.variantId || productId,
        currency: button.dataset.currency || ''
      });
      button.classList.add('is-active');
    }
    
    this.updateHeaderCount();
    
    // If we're on the wishlist page, reload the items
    if (this.wishlistContainer) {
      this.loadWishlistItems();
    }
  }

  addToWishlist(product) {
    if (!this.isInWishlist(product.id)) {
      this.wishlistItems.push(product);
      localStorage.setItem(this.storageKey, JSON.stringify(this.wishlistItems));
    }
  }

  removeFromWishlist(productId) {
    this.wishlistItems = this.wishlistItems.filter(item => item.id !== productId);
    localStorage.setItem(this.storageKey, JSON.stringify(this.wishlistItems));
  }

  isInWishlist(productId) {
    return this.wishlistItems.some(item => item.id === productId);
  }

  updateHeaderCount() {
    if (this.headerWishlistCount) {
      this.headerWishlistCount.textContent = this.wishlistItems.length;
      
      if (this.wishlistItems.length > 0) {
        this.headerWishlistCount.classList.add('has-items');
      } else {
        this.headerWishlistCount.classList.remove('has-items');
      }
    }
  }

  loadWishlistItems() {
    if (!this.wishlistContainer) return;
    
    // Clear current items
    this.wishlistContainer.innerHTML = '';
    
    if (this.wishlistItems.length === 0) {
      this.wishlistEmpty.classList.remove('hidden');
      return;
    }
    
    this.wishlistEmpty.classList.add('hidden');
    
    // Add items to the wishlist page
    this.wishlistItems.forEach(item => {
      const productCard = this.createProductCard(item);
      this.wishlistContainer.appendChild(productCard);
    });

    // Initialize wishlist buttons on the created cards
    this.initButtons();
  }


  

  createProductCard(item) {
    // Format price using store's currency settings
    
    const card = document.createElement('div');
    card.className = 'grid__item';
    
    // Use data attributes to store variant ID for adding to cart
    const variantId = item.variant_id || item.id;
    
    card.innerHTML = `
      <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--product card--media" tabindex="-1">
          <div class="card__inner">
            <div class="card__wishlist card__wishlist--overlay">
              <button class="wishlist-button is-active" 
                data-product-id="${item.id}" 
                data-product-handle="${item.handle}" 
                data-product-title="${item.title}"
                data-product-url="${item.url}"
                data-product-image="${item.image}"
                data-product-price="${item.price}"
                data-raw-price="${item.raw_price || ''}"
                data-variant-id="${variantId}"
                data-currency="${item.currency || ''}"
                aria-label="Remove from wishlist">
                <span class="wishlist-button__icon wishlist-button__icon--outline">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                </span>
                <span class="wishlist-button__icon wishlist-button__icon--filled">
                <svg xmlns="http://www.w3.org/2000/svg"   width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="currentColor"></path>
                </svg>
                </span>
              </button>
            </div>
            <a href="${item.url}" class="full-unstyled-link">
              <div class="card__media">
                <img
                  src="${item.image}"
                  alt="${item.title}"
                  loading="lazy"
                  class="motion-reduce"
                  width="533"
                  height="720"
                >
              </div>
            </a>
            <div class="card__content">
              <div class="card__information">
                <h5 class="card__heading">
                  <a href="${item.url}" class="full-unstyled-link">
                    ${item.title}
                  </a>
                </h5>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    `;
    
    return card;
  }

  // Version OK : 

addToCart(variantId) {
  fetch('/?section_id=cart-icon-bubble')
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var newHeader = parser.parseFromString(html, 'text/html');
      var newBubble = newHeader.querySelector('.cart-count-bubble');
      var headerIconWrapper = document.querySelector('header .header__icons');
      var oldBubble = headerIconWrapper.querySelector('.cart-count-bubble');
      
      if (newBubble) {
        if (oldBubble) {
          oldBubble.parentNode.replaceChild(newBubble, oldBubble);
        } else if (headerIconWrapper) {
          var cartIcon = headerIconWrapper.querySelector('.header__icon--cart');
          if (cartIcon) {
            cartIcon.appendChild(newBubble.cloneNode(true));
          }
        }
      }
    });
}


}


// Initialize wishlist when DOM is loaded
window.Wishlist = null;
document.addEventListener('DOMContentLoaded', () => {
  window.Wishlist = new Wishlist();
});